import React from "react";
import styles from './Error.scss'

export default function Error() {
    return (
        <section className="error">
            <h2>:( Упс! Виникла помилка, спробуйте ще раз</h2>
        </section>
    );
}